// Tool types for the whiteboard
export const ToolType = {
  PAN: 'PAN',
  SELECT: 'SELECT',
  TEXT: 'TEXT',
  PEN: 'PEN',
  MARKER: 'MARKER',
  ERASER: 'ERASER',
  SHAPE: 'SHAPE',
};

// Shape types for the shape tool
export const ShapeType = {
  RECTANGLE: 'RECTANGLE',
  CIRCLE: 'CIRCLE',
  LINE: 'LINE',
  ARROW: 'ARROW',
  TRIANGLE: 'TRIANGLE',
};

// Element types for draggable objects
export const ElementType = {
  NOTE: 'NOTE',
  MATH: 'MATH',
  TEXT: 'TEXT',
  CHART: 'CHART',
  WORKSHEET: 'WORKSHEET',
  FBD: 'FBD',
};

// Default colors for drawing tools
export const COLORS = [
  '#000000', // Black
  '#ef4444', // Red
  '#3b82f6', // Blue
  '#22c55e', // Green
  '#a855f7', // Purple
  '#f97316', // Orange
];

export const FORCE_COLOR_OPTIONS = [
  { hex: '#000000', name: 'Black' },
  { hex: '#ef4444', name: 'Red' },
  { hex: '#3b82f6', name: 'Blue' },
  { hex: '#22c55e', name: 'Green' },
  { hex: '#a855f7', name: 'Purple' },
  { hex: '#f97316', name: 'Orange' },
];

// Note background colors
export const NOTE_COLORS = [
  '#fff9c4', // Yellow
  '#f8bbd9', // Pink
  '#b3e5fc', // Blue
  '#c8e6c9', // Green
  '#e1bee7', // Purple
];

// Helper to generate unique IDs
export const generateId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

// Default element factories
export const createNoteElement = (x, y) => ({
  id: generateId(),
  type: ElementType.NOTE,
  x,
  y,
  width: 280,
  height: 260,
  content: '',
  color: NOTE_COLORS[0],
  annotations: [],
});

export const createMathElement = (x, y) => ({
  id: generateId(),
  type: ElementType.MATH,
  x,
  y,
  width: 640,
  height: 420,
  expression: '',
  rawInput: '',
  isEditing: true,
});

export const createTextElement = (x, y) => ({
  id: generateId(),
  type: ElementType.TEXT,
  x,
  y,
  width: 520,
  height: 180,
  content: '',
});

export const createChartElement = (x, y) => ({
  id: generateId(),
  type: ElementType.CHART,
  x,
  y,
  width: 560,
  height: 420,
  expressions: 'y=x^2',
  annotations: [],
});

export const createFbdElement = (x, y) => ({
  id: generateId(),
  type: ElementType.FBD,
  x,
  y,
  width: 420,
  height: 320,
  bodyLabel: 'Object',
  forces: [
    {
      id: generateId(),
      label: 'F',
      magnitude: 10,
      directionDeg: 0,
      color: '#3b82f6',
    },
  ],
});

export const createWorksheetElement = ({
  x,
  y,
  width = 540,
  height = 720,
  assetId,
  assetType,
  src,
  pdfMeta = null,
}) => ({
  id: generateId(),
  type: ElementType.WORKSHEET,
  x,
  y,
  width,
  height,
  assetId,
  assetType,
  src,
  pdfMeta,
  annotations: [],
});

// Create a shape object
export const createShape = (type, x1, y1, x2, y2, color, strokeWidth = 3) => ({
  id: generateId(),
  type,
  x1,
  y1,
  x2,
  y2,
  color,
  strokeWidth,
  fill: null,
});
